import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { ThemeProvider } from './contexts/ThemeContext';
import { Toaster } from 'sonner';
import { AlertProvider } from './context/AlertContext';

export default function App() {
  return (
    <ThemeProvider>
      <AlertProvider>
        <Toaster position="top-right" richColors closeButton />
        <RouterProvider router={router} />
      </AlertProvider>
    </ThemeProvider>
  );
}
